import React from 'react'
import './Loader.css'

const Loader = (props) => {
	const { className } = props
	return <div className={`loader ${className}`}></div>
}

export default Loader
